// extracted by mini-css-extract-plugin
export default {"formContact":"Contact_formContact__cp-lJ","formTitle":"Contact_formTitle__0wyEP"};